import React, { useState, useEffect } from 'react';
import { Box, Button, Card, Container, CssBaseline, FormControl, FormGroup, Grid, InputAdornment, InputLabel, LinearProgress, MenuItem, Select, TextField, Typography, styled } from '@mui/material';
import { ArrowBack, ArrowForward, Cancel, Search } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import TableComponent from './Components/TableComponent';
import BasicTable from './Components/BasicTable';



const GridBlockContent = styled("div")(({ theme }) => ({
    display: "grid",
    maxWidth: "100%",
    gridTemplateColumns: "auto",
    gap: "1px solid #ccc",
    fontFamily: "'Trebechut' sans-serif",
    fontSize: "14px",
    fontWeight: "bold",
}));

const GridBlockTitle = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #f1f1f1",
    backgroundColor: "#f5f5f5",
    color: "#2a2a2a",
    padding: "16px",
    fontSize: "16px",
    textAlign: "left",
    textTransform: "uppercase",

}));

const Code = styled("div")(({ theme }) => ({
    width: "100px",
    fontSize: "20px",

}));
const Name = styled("div")(({ theme }) => ({
    width: "380px",
    fontSize: "20px",

}));
const FlexContent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    fontSize: "17px",
    marginBottom: "10px",
    alignItems: "flex-start",
}));

const FlexInnerTitle = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: "210px",
    maxWidth: "320px",
    fontWeight: "600",
}));



const demoList = [
    {
        school: 'ABC School',
        salesID: 'S001',
        ageing: 30,
        type: 'Primary',
        mobile: '123-456-7890',
        email: 'abc@example.com'
    },
    {
        school: 'XYZ School',
        salesID: 'S002',
        ageing: 45,
        type: 'Secondary',
        mobile: '987-654-3210',
        email: 'xyz@example.com'
    },
    {
        school: '123 School',
        salesID: 'S003',
        ageing: 25,
        type: 'High School',
        mobile: '555-555-5555',
        email: '123@example.com'
    },

];


const columns = [
    { id: 'school', name: 'School Name' },
    { id: 'salesID', name: 'Sales ID' },
    { id: 'ageing', name: 'Ageing' },
    { id: 'type', name: 'Type' },
    { id: 'mobile', name: 'Mobile Number' },
    { id: 'email', name: 'Email Address' }
];


const test = () => {


    return (
        <div>
            <Container component="main" maxWidth="l" style={{ textAlign: 'center', marginTop: '20px' }}>
                <CssBaseline />
                <Card>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <FormGroup>
                                <GridBlockContent>
                                    <GridBlockTitle>
                                        <Box p={2} pb={2} sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'flex-start' }}>

                                            <Code>3R100</Code>
                                            <Name>PSW Cheltanhem Retail Outlet</Name>
                                        </Box>
                                        <Box textAlign={"right"}>
                                            <Link to="">
                                                <Button color="error" variant="contained" >

                                                    <b>Exit</b>
                                                    <ArrowForward sx={{ marginRight: "10px" }} />
                                                </Button>
                                            </Link>
                                        </Box>
                                    </GridBlockTitle>
                                </GridBlockContent>
                            </FormGroup>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={6}>
                            <Card sx={{ background: "#f5f5f5" }}>
                                <Box p={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={10}>
                                            <FlexContent>
                                                <FlexInnerTitle>
                                                    <span>Delivery Type</span>
                                                </FlexInnerTitle>

                                                <FormControl fullWidth sx={{ m: 1 }} size="small">

                                                    <Select
                                                        //value={}
                                                        //onChange={}
                                                        displayEmpty
                                                        inputProps={{ 'aria-label': 'Without label' }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <MenuItem value={10}>Demo1</MenuItem>
                                                        <MenuItem value={20}>Demo2</MenuItem>
                                                        <MenuItem value={30}>Demo3</MenuItem>
                                                    </Select>
                                                </FormControl>

                                            </FlexContent>

                                            <FlexContent>
                                                <FlexInnerTitle>
                                                    <span>Customer</span>
                                                </FlexInnerTitle>

                                                <FormControl fullWidth sx={{ m: 1 }} size="small">
                                                    <Select
                                                        //value={}
                                                        //onChange={}
                                                        displayEmpty
                                                        inputProps={{ 'aria-label': 'Without label' }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <MenuItem value={10}>Demo1</MenuItem>
                                                        <MenuItem value={20}>Demo2</MenuItem>
                                                        <MenuItem value={30}>Demo3</MenuItem>
                                                    </Select>
                                                </FormControl>

                                            </FlexContent>

                                        </Grid>
                                        <Grid item xs={2}>
                                            <Box textAlign="right"  >
                                                <Link to="">
                                                    <Button
                                                        size="large"
                                                        variant="contained"
                                                        color="primary"
                                                        sx={{
                                                            margin: "10px",
                                                            borderRadius: '10px',
                                                            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                        }}
                                                    >
                                                        Reset Filter
                                                    </Button>
                                                </Link>
                                            </Box>

                                        </Grid>
                                    </Grid>
                                </Box>
                            </Card>

                            <Box p={1} sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'flex-start' }}>

                                <p style={{ fontWeight: "bold" }}>To be picked</p>
                                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                    <Select
                                        //value={}
                                        //onChange={}
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Without label' }}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value={10}>Demo1</MenuItem>
                                        <MenuItem value={20}>Demo2</MenuItem>
                                        <MenuItem value={30}>Demo3</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            <BasicTable
                                columns={columns}
                                rows={demoList}

                            />




                        </Grid>
                        <Grid item md={6} paddingTop={"4%"}>
                            <Card>
                                <Box p={1} sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'flex-start' }}>

                                    <p style={{ fontWeight: "bold" }}>Preparing Order</p>
                                </Box>
                            </Card>
                            <Grid container spacing={0}>
                                <Grid item md={2}>
                                    <Box textAlign="left">
                                        <Link to="">
                                            <Button
                                                size="large"
                                                variant="contained"
                                                color="success"

                                                sx={{
                                                    margin: "10px",
                                                    borderRadius: '10px',
                                                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                }}
                                            >
                                                Print PS Label
                                            </Button>
                                        </Link>
                                    </Box>
                                    <Box textAlign="left">
                                        <Link to="">
                                            <Button
                                                size="large"
                                                variant="contained"
                                                color="success"
                                                sx={{
                                                    margin: "10px",
                                                    borderRadius: '10px',
                                                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                }}
                                            >
                                                Print Order
                                            </Button>
                                        </Link>
                                    </Box>
                                    <Box textAlign="left">
                                        <Link to="">
                                            <Button
                                                size="large"
                                                variant="contained"
                                                color="warning"
                                                sx={{
                                                    margin: "10px",
                                                    borderRadius: '10px',
                                                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                }}
                                            >
                                                View Order
                                            </Button>
                                        </Link>
                                    </Box>
                                    <Box textAlign="left">
                                        <Link to="">
                                            <Button
                                                size="large"
                                                variant="contained"
                                                color="error"
                                                sx={{
                                                    margin: "10px",
                                                    borderRadius: '10px',
                                                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                }}
                                            >
                                                Unpick Order
                                            </Button>
                                        </Link>
                                    </Box>
                                </Grid>
                                <Grid item md={10}>
                                    <BasicTable
                                        columns={columns}
                                        rows={demoList}

                                    />
                                </Grid>
                                <Grid item md={12}>
                                    <Card sx={{ background: "#f5f5f5", display: 'flex', justifyContent: "space-between", alignItems: 'flex-start' }}>
                                        <Box >
                                            <Link to="">
                                                <Button
                                                    size="large"
                                                    variant="contained"
                                                    color="warning"
                                                    sx={{
                                                        margin: "10px",
                                                        borderRadius: '10px',
                                                        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                    }}
                                                >
                                                    Partial order Picked
                                                </Button>
                                            </Link>
                                        </Box>
                                        <Box >
                                            <TextField sx={{ width: "300px" }} />
                                        </Box>
                                        <Box >
                                            <Link to="">
                                                <Button
                                                    size="large"
                                                    variant="contained"
                                                    color="success"
                                                    sx={{
                                                        margin: "10px",
                                                        borderRadius: '10px',
                                                        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                    }}
                                                >
                                                    Invoice Order In Full
                                                </Button>
                                            </Link>
                                        </Box>
                                    </Card>

                                </Grid>


                            </Grid>
                            <Grid container spacing={2}>

                            </Grid>

                        </Grid>
                    </Grid>
                    <Grid item spacing={0}>
                        <Box p={1} sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'flex-start' }}>

                            <p style={{ fontWeight: "bold" }}>Ready for collection</p>
                        </Box>
                        <Grid item md={12}>
                            <BasicTable
                                columns={columns}
                                rows={demoList}

                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormGroup>
                                <GridBlockContent>
                                    <GridBlockTitle>
                                        <Box pb={2} sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'flex-start' }}>

                                            <Box >
                                                <Link to="">
                                                    <Button
                                                        size="large"
                                                        variant="contained"
                                                        color="error"
                                                        sx={{
                                                            margin: "10px",
                                                            borderRadius: '10px',
                                                            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                        }}
                                                    >
                                                        Push Back To Pick
                                                    </Button>
                                                </Link>
                                            </Box>
                                            <Box >
                                                <TextField sx={{ width: "300px" }} />
                                            </Box>
                                            <Box >
                                                <TextField sx={{ width: "300px" }} />
                                            </Box>
                                            <Box >
                                                <Link to="">
                                                    <Button
                                                        size="large"
                                                        variant="contained"
                                                        color="success"
                                                        sx={{
                                                            margin: "10px",
                                                            borderRadius: '10px',
                                                            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                        }}
                                                    >
                                                        Order Collected
                                                    </Button>
                                                </Link>
                                            </Box>
                                        </Box>
                                        <Box textAlign={"right"}>
                                            <Link to="">
                                                <Button sx={{ background: "#888888" }} variant="contained" >

                                                    <b>Query History</b>

                                                </Button>
                                            </Link>
                                        </Box>
                                    </GridBlockTitle>
                                </GridBlockContent>
                            </FormGroup>
                        </Grid>
                    </Grid>
                </Card>
            </Container>
        </div >
    );
}

export default test;

